import React from 'react'
import { usePipeline } from '@morningtrain/react-helpers'

export default function TriggerPipelineOnChange ({ children }) {
  const pipeline = usePipeline()

  const handleChange = (value) => {
    pipeline.trigger({
      value: value
    })
  }

  return React.Children.map(children, (child) => (
    React.cloneElement(child, { onChange: handleChange })
  ))
}
